/**
 * NOTE: The navigator object and user agent string can be faked. Never rely on these values being completely accurate.
 */

/**
 * Determines if the runtime is a browser
 */
export const isBrowser = typeof window !== 'undefined';

/**
 * detect IE
 * returns version of IE/Edge or false, if browser is not Internet Explorer
 */
export function _detectIE(): number | false {
  if (!isBrowser) return false;

  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

export const msieVersion = _detectIE();

// See https://stackoverflow.com/a/19883965/5899933 for a list of platforms
export function _detectIOS(): boolean {
  // There is some iOS in Windows Phone...
  // https://msdn.microsoft.com/en-us/library/hh869301(v=vs.85).aspx
  return isBrowser && /iPhone|iPad|iPod|Pike/.test(window.navigator.platform) && !(window as any).MSStream;
}

export const isIOS = _detectIOS();
